<template>
    <div>
        <el-row>
            <el-col :span="24">订单总金额：{{ order_money }}元。<span v-if="order_share_shou">扣除手续费：{{ order_share_shou.share_income }}元({{ order_share_shou.share_scale }}%)</span></el-col>
        </el-row>
        <el-table :data="order_share_list" style="width: 100%">
            <el-table-column prop="share_name" label="分成对象"></el-table-column>
            <el-table-column prop="share_scale" label="分成占比(%)">
                <template slot-scope="scope">
                    <el-tag type="info">{{scope.row.share_scale}}</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="share_income" label="分成收入">
                <template slot-scope="scope">
                    {{scope.row.share_income}}元
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
export default {
  props:{
    order_id: {
        type: Number | String,
        default: 0
    },
    order_money: {
        type: String,
        default: ''
    }
},
  data () {
    return {
        order_share_list:[],
        order_share_shou:[],
    }
  },
  methods:{
     //获取分成占比
    getOrderShare(){
        let _this=this;
        _this.$axios.post('getOrderShare',{order_id:_this.order_id}).then(res=>{
            if(res.data.code==200){
                _this.order_share_list=res.data.data.share_list;
                _this.order_share_shou=res.data.data.share_shou;
            }
            else{
                this.$Message.error(res.data.message)
            }
        }).catch( function(response) {
            console.log(response)
        });
    },
  },
  created(){
      this.getOrderShare();  
  }
}
</script>


// WEBPACK FOOTER //
// src/components/finance/OrderShare.vue